import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import Device from '../../../devices/device';

const DEFAULT_REGION = 'default';

/**
 * Base class for local (bundled JSON) editorial values.
 *
 * Expects a JSON object shaped as:
 * { "<appKey>": { key: { default: value, <region>: value, ... } } }
 *
 * The active appKey and region are read from the same sources the rest of
 * the app already uses (Device.getDevice().getConfig().appKey, same as
 * ApaMetadataTask's sessionKey; DeviceStorage 'region'), so consumers never
 * filter by appKey or region themselves.
 */
class LocalApa {
  constructor(json = {}) {
    this.dataByAppKey = json || {};
  }

  getAppKey() {
    try {
      return Device.getDevice().getConfig().appKey;
    } catch (e) {
      return null;
    }
  }

  getRegion() {
    return DeviceStorage.getItem('region') || DEFAULT_REGION;
  }

  // Resolves the key->regions map for the active appKey. Falls back to the
  // first appKey block bundled in the JSON when the active appKey has no
  // data of its own (e.g. a device whose appKey wasn't exported yet).
  getData() {
    const appKey = this.getAppKey();
    if (appKey && this.dataByAppKey[appKey]) {
      return this.dataByAppKey[appKey];
    }
    const firstAppKey = Object.keys(this.dataByAppKey)[0];
    return firstAppKey ? this.dataByAppKey[firstAppKey] : {};
  }

  // Same contract as Apa.get(key, default): empty values give the default; missing keys give the default or the key.
  get(key, defaultText = null) {
    const entry = this.getData()[key];
    if (entry !== undefined && entry !== null) {
      const region = this.getRegion();
      const value = entry[region] !== undefined ? entry[region] : entry[DEFAULT_REGION];
      if (value !== undefined) {
        if (typeof value === 'string' && value.trim() === '') return defaultText;
        return value;
      }
    }
    return defaultText !== null ? defaultText : key;
  }
}

export default LocalApa;



// WEBPACK FOOTER //
// ./src/requests/apa/local/LocalApa.js